import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'What is SyNeural?',
    answer: 'SyNeural develops connected knowledge infrastructure and human capability systems. Its work has three complementary parts: the Semantic Knowledge Platform (SKP), which connects and governs institutional knowledge, evidence, relationships and provenance; the Human Capability Framework (HCF), which structures assessment, development and review through CJI and NCJI; and Noetivra, the visual, interactive workspace connecting knowledge, assessment, development, services and institutional operations.'
  }, {
    question: 'How do CJI and NCJI relate?',
    answer: 'Both sit within the Human Capability Framework. CJI supports structured reasoning and judgment assessment. NCJI uses a five-pillar working architecture for civic judgment and development: Evidence and Reality Testing, Emotional Regulation, Consequential and Long-Term Reasoning, Manipulation Resistance, and Responsible Agency and Civic Reciprocity. Both instruments remain under development.'
  }, {
    question: 'Is NCJI just a score?',
    answer: 'No. NCJI presents a five-pillar profile rather than an overall intelligence score, civic rank or eligibility rating. Each finding is reviewed and linked to a development activity, and where a task does not support an interpretation, the finding is marked “Insufficient evidence” rather than treated as low performance.'
  }, {
    question: 'Who is the framework for?',
    answer: 'The framework is designed for multiple layers of society: educational institutions developing youth capability, employers seeking better execution and leadership, civil society organizations building resilience, and governments modernizing civil service and executive readiness.'
  }, {
    question: 'How does it scale globally?',
    answer: 'The framework is designed for municipal, regional, and national use. It could support localized insight for community development and aggregate analysis for national capability planning. Aggregate patterns are not judgments about individuals, and any large-scale use would require appropriate validation, privacy protections, and oversight.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-992" data-mp="33mep2f1oo8ml">
      <div className="text-center mb-12" data-id="element-993" data-mp="33kbo4zyzsv33">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-994" data-mp="2yms8pwqk6c9k">
          Frequently Asked Questions
        </h2>
      </div>

      <div className="space-y-4" data-id="element-995" data-mp="2ulgipq3rvp0u">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="border border-line rounded-lg bg-white overflow-hidden" data-id="element-996" data-mp="1n97mxfjtjy5c" data-mpi={index}>
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-997" data-mp="cggnsvxrw803">
              <span className="text-lg font-heading font-bold text-ink-dark pr-8" data-id="element-998" data-mp="mfxungorgrxn">
                {faq.question}
              </span>
              <span className="text-navy flex-shrink-0" data-id="element-999" data-mp="vfb2y615fags">
                {openIndex === index ? <Minus size={20} data-id="element-1000" data-mp="2s7bb9img0wx2" /> : <Plus size={20} data-id="element-1001" data-mp="2s7uv54vnlvdq" />}
              </span>
            </button>

            <AnimatePresence data-id="element-1002" data-mp="2x5wd1mhcfonm">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-1003" data-mp="2x88ttwbd7sz3">
                  <div className="px-6 pb-6 text-ink-muted leading-relaxed" data-id="element-1004" data-mp="1e6ezmfh1mqeg">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}